import React, { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { Droppable } from 'react-beautiful-dnd';

type DroppableTableProps = {
  id: string;
  children?: ReactNode;
  isEmpty?: boolean;
  emptyTableMessage?: string;
  isDropDisabled?: boolean;
  type?: string;
};

const DroppableTable = ({
  children,
  id,
  isEmpty,
  type,
  isDropDisabled = false,
  emptyTableMessage = 'Drop items here',
}: DroppableTableProps) => {
  return (
    // Will not work locally because of Strict Mode - https://github.com/atlassian/react-beautiful-dnd/issues/2396#issuecomment-1195570350
    <Droppable type={type} droppableId={id} isDropDisabled={isDropDisabled}>
      {(droppableProvided, { isDraggingOver }) => (
        <Table {...droppableProvided.droppableProps} ref={droppableProvided.innerRef} data-qa={id} size="small">
          {children}
          <TableBody>
            {isEmpty && !isDraggingOver && (
              <TableRow>
                <TableCell align="center" colSpan={10}>
                  {emptyTableMessage}
                </TableCell>
              </TableRow>
            )}
            {droppableProvided.placeholder}
          </TableBody>
        </Table>
      )}
    </Droppable>
  );
};

export default DroppableTable;
